export default __webpack_public_path__ + "static/media/BenefitsIcon4.0197f8c7.svg";